﻿cb.define([], function () {
  var ST_st_storeinlist_VM_Extend = {
    doAction: function (name, viewmodel) {
      if (this[name])
        this[name](viewmodel);
    },
    init: function (viewmodel) {
      let gridModel = viewmodel.getGridModel();
      gridModel.on('afterSetDataSource', () => {

        const rows = gridModel.getRows();
        const actions = gridModel.getCache('actions');
        const actionsStates = [];
        rows.forEach(data => {
          const actionState = {};
          actions.forEach(action => {
            actionState[action.cItemName] = { visible: true };
            if (data.status == "1") {
              if (action.cItemName == "btnEdit" || action.cItemName == "btnDelete" || action.cItemName == "btnAudit")
                actionState[action.cItemName] = { visible: false };
            }
          });
          actionsStates.push(actionState);
        });
        gridModel.setActionsState(actionsStates);
      })
    }
  }
  try {
    module.exports = ST_st_storeinlist_VM_Extend;
  } catch (error) {

  }
  return ST_st_storeinlist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_storeinlist_VM.Extend.js